import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { UserType } from "@/utils/user-type-checker";

export type ActionType = "create" | "edit";

export interface PrivateOfficeConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  userType: UserType;
  actionType: ActionType;
}

interface ModalMessages {
  title: string;
  description: string;
}

function getModalMessages(
  userType: UserType,
  actionType: ActionType,
): ModalMessages {
  if (userType === "internal") {
    if (actionType === "create") {
      return {
        title: "Sala enviada para análise",
        description:
          "A sala e todas as informações cadastradas foram enviadas para análise e estão aguardando aprovação da equipe.",
      };
    } else {
      return {
        title: "Alterações enviadas para análise",
        description:
          "As alterações realizadas na sala foram enviadas para análise e estão aguardando aprovação da equipe.",
      };
    }
  }

  if (userType === "partner") {
    if (actionType === "create") {
      return {
        title: "Sala enviada para análise",
        description:
          "A sala e todas as informações cadastradas foram enviadas para análise e estão aguardando aprovação. Se alguma informação precisar de ajuste, o time da Woba entrará em contato para orientar os ajustes necessários.",
      };
    } else {
      return {
        title: "Alterações enviadas para análise",
        description:
          "As alterações realizadas na sala foram enviadas para análise. Se alguma informação precisar de ajuste, o time da Woba entrará em contato.",
      };
    }
  }

  return {
    title: "",
    description: "",
  };
}

export const PrivateOfficeConfirmationModal: React.FC<
  PrivateOfficeConfirmationModalProps
> = ({ isOpen, onClose, userType, actionType }) => {
  const { title, description } = getModalMessages(userType, actionType);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onClose}>OK</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
